module.exports = __webpack_public_path__ + "img/flag_no.0fe64b80.svg";